import { useState } from "react";
import "../assets/css/researcher.css";
import axios from "axios";
import { SiResearchgate } from "react-icons/si";
import { FaGoogleScholar } from "react-icons/fa6";

const Card = ({ item }) => {
    return (
        <article className="card">
            <img
                src={item.avatar}
                alt="researcher"
                className="researcher-avatar"
            />
            <div className="card-content">
                <div style={{ marginBottom: "auto" }}>
                    <p className="category">{item.major_title}</p>
                    <p className="nameTh">
                        {item.titlePosition}
                        {item.firstName} {item.lastName}
                    </p>
                    <p className="nameEn">
                        {item.titlePositionEn}
                        {item.firstNameEn} {item.lastNameEn}
                    </p>
                    <p className="description">{item.expertise}</p>
                </div>

                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-around",
                        gap: "10px",
                        marginTop: "20px",
                    }}
                >
                    {item.researchGateUrl && (
                        <a
                        title="goto ResearchGate Profile"
                            href={item.researchGateUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btnResearchGate"
                        >
                            <div style={{color:"#FFF", textAlign:"center"}}><SiResearchgate style={{ fill: 'white' }} /></div>
                            ResearchGate
                        </a>
                    )}
                    {item.scholarUrl && (
                        <a
                        title="goto Google Scholar Profile"
                            href={item.scholarUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btnGoogleScholar"
                        >
                            <div style={{textAlign:"center"}}><FaGoogleScholar style={{ fill: 'white' }} /></div>
                            Google Scholar
                        </a>
                    )}
                </div>
            </div>
        </article>
    );
};

export default function Researcher() {
    const [researchers, setResearchers] = useState(null);
    const [resFiltered, setResFiltered] = useState(null);

    if (!researchers) {
        axios
            .get("https://arch.mju.ac.th/json/research/researcher.json")
            .then((res) => {
                setResearchers(res.data);
                console.log("Fetched researchers:", res.data);
            })
            .catch((err) => {
                console.error("Error fetching researchers:", err);
            });
        // setResearchers
    }

    if (researchers && !resFiltered) {
        setResFiltered(researchers);
    }

    const handleFilter = (e) => {
        const query = e.target.value.toLowerCase();
        const filtered = researchers.filter((res) => {
            const fullNameTh =
                `${res.titlePosition}${res.firstName} ${res.lastName}`.toLowerCase();
            const fullNameEn =
                `${res.titlePositionEn}${res.firstNameEn} ${res.lastNameEn}`.toLowerCase();
            return (
                fullNameTh.includes(query) ||
                fullNameEn.includes(query) ||
                res.expertise.toLowerCase().includes(query) ||
                res.major_title.toLowerCase().includes(query)
            );
        });
        setResFiltered(filtered);
    };

    return (
        <div
            style={{
                background: "#f8f4ef",
                color: "#2a1a0d",
                lineHeight: "1.6",
            }}
        >
            <div id="header">
                <div className="container">
                    <p className="page-website">arch.mju.ac.th</p>
                    <p className="page-title">รายชื่อนักวิจัย</p>
                    <p className="page-subtitle">
                        คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม
                        มหาวิทยาลัยแม่โจ้
                    </p>
                </div>
            </div>

            {researchers?.length && (
                <main style={{ padding: "60px 0" }}>
                    <div className="container">
                        <div className="page-subheader">
                            <div>
                                <p className="page-title">
                                    Researcher Directory
                                </p>
                                <p className="page-description">
                                    ค้นหาและติดตามนักวิจัยของคณะฯ
                                </p>
                            </div>

                            <div id="search-box">
                                <input
                                    type="text"
                                    placeholder="ค้นหาชื่อนักวิจัย..."
                                    onChange={handleFilter}
                                />
                            </div>
                        </div>

                        <section className="cards">
                            {resFiltered?.map(
                                (item, index) =>
                                    (item.researchGateUrl ||
                                        item.scholarUrl) && (
                                        <Card key={index} item={item} />
                                    ),
                            )}
                        </section>
                    </div>
                </main>
            )}
        </div>
    );
}
